import { computeMortgage } from './compute';
import { classifyVerdict } from './verdict';
import { RULE_VERSION } from './rules';
import type { MortgageResult, Verdict } from './types';

export interface Evaluation {
  result: MortgageResult;
  verdict: Verdict;
  ruleVersion: string;
}

/** Convenience: compute the figures and classify the verdict in one call. */
export function evaluate(price: number, income: number, equityCHF: number): Evaluation {
  const result = computeMortgage(price, income, equityCHF);
  return { result, verdict: classifyVerdict(result), ruleVersion: RULE_VERSION };
}
